import { Provider as Root } from './Provider'
import { CardFront } from 'components/SecretIdentity/CardFront'
import { CardBack } from './CardBack'
import { DownloadButton } from './DownloadButton'
import { ShareButton } from './ShareButton'
import { Popout3D } from './Popout3D'
import { SelectAvatarButton } from './SelectAvatarButton'
import { RefreshAvatarIconButton } from './RefreshAvatarIconButton'

export const SecretIdentity = {
  Root,
  CardFront,
  CardBack,
  Popout3D,
  DownloadButton,
  ShareButton,
  SelectAvatarButton,
  RefreshAvatarIconButton,
}
